import deepCopy from '@/utils/deepCopy';
import instanceOfReference from '@/utils/instanceOfReference';

const flattenFiltersAggregateValues = (data: Record<string, unknown>) => {
  const copyData = deepCopy(data);

  Object.entries(copyData).forEach(([key, value]) => {
    let flattenedUniqueValue = value;

    // TODO: Сплющивание массива из за некорректной агрегации
    if (Array.isArray(flattenedUniqueValue)) {
      flattenedUniqueValue = flattenedUniqueValue.flat();
      copyData[key] = flattenedUniqueValue;
    }

    // TODO: Удаление повторения в фильтрах из за некорректной агрегации
    if (
      Array.isArray(flattenedUniqueValue) &&
      flattenedUniqueValue.length &&
      instanceOfReference(flattenedUniqueValue[0])
    ) {
      flattenedUniqueValue = flattenedUniqueValue.filter(
        (v, i, a) => a.findIndex(v2 => v2.id === v.id) === i,
      );
      copyData[key] = flattenedUniqueValue;
    }
  });

  return copyData;
};

export default flattenFiltersAggregateValues;
